module.exports = __webpack_public_path__ + "img/messages_empty.9c541638.png";